import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=20e3f46a&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=20e3f46a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e3f46a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e3f46a')) {
      api.createRecord('20e3f46a', component.options)
    } else {
      api.reload('20e3f46a', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=20e3f46a&scoped=true&", function () {
      api.rerender('20e3f46a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cE7ROn3Mp21S/JS/comp/PopupDialog.vue"
export default component.exports